<template>
  <div>
    <span class="body-2 mr-8 mt-4">{{ i18n(translations.averageRating) }}</span>
    <RevRating :score="rating" size="small" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevRating } from '@ds/components/Rating'

import translations from './AverageRating.translations'

defineProps<{ rating: number }>()

const i18n = useI18n()
</script>
